var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3374 22.9713C3.3374 25.5975 5.2604 27.7269 7.6328 27.7269C10.0046 27.7269 11.9276 25.5975 11.9276 22.9713H3.3374Z",
    fill: "#EDEDED",
    stroke: "#004733",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3403 22.9713C21.3403 25.5975 23.2633 27.7269 25.6351 27.7269C28.0075 27.7269 29.9305 25.5975 29.9305 22.9713H21.3403Z",
    fill: "#EDEDED",
    stroke: "#004733",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.1538H1.81651C0.813872 13.1538 0 12.5434 0 11.7921V11.5162C0 10.7636 0.813872 10.1538 1.81651 10.1538H4V13.1538Z",
    fill: "#EDEDED",
    stroke: "#004733",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 13.1538H31.6373C32.3897 13.1538 33 12.5434 33 11.7921V11.5162C33 10.7636 32.3897 10.1538 31.6373 10.1538H30V13.1538Z",
    fill: "#EDEDED",
    stroke: "#004733",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5562 11.9242C30.6621 12.0723 30.7245 12.2537 30.7245 12.4497V22.0665C30.7245 22.5657 30.3189 22.9713 29.8197 22.9713H3.48927C2.98947 22.9713 2.58447 22.5657 2.58447 22.0665V12.4497C2.58447 12.1864 2.69683 11.9495 2.87623 11.7841L6.16569 4.60749C7.27869 2.25429 9.64869 0.753693 12.2515 0.753693H20.8471C23.3965 0.753693 25.7269 2.19309 26.8675 4.47309L30.5562 11.9242Z",
    fill: "#017848"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5562 11.9242L30.1081 12.146L30.126 12.1822L30.1495 12.215L30.5562 11.9242ZM2.87623 11.7841L3.21507 12.1518L3.28891 12.0838L3.33075 11.9925L2.87623 11.7841ZM6.16569 4.60749L5.71367 4.3937L5.71116 4.39916L6.16569 4.60749ZM26.8675 4.47309L27.3156 4.25126L27.3147 4.24939L26.8675 4.47309ZM30.1495 12.215C30.1968 12.2811 30.2245 12.3615 30.2245 12.4497H31.2245C31.2245 12.1459 31.1274 11.8634 30.9629 11.6333L30.1495 12.215ZM30.2245 12.4497V22.0665H31.2245V12.4497H30.2245ZM30.2245 22.0665C30.2245 22.2895 30.0427 22.4713 29.8197 22.4713V23.4713C30.595 23.4713 31.2245 22.8418 31.2245 22.0665H30.2245ZM29.8197 22.4713H3.48927V23.4713H29.8197V22.4713ZM3.48927 22.4713C3.26583 22.4713 3.08447 22.2897 3.08447 22.0665H2.08447C2.08447 22.8416 2.71311 23.4713 3.48927 23.4713V22.4713ZM3.08447 22.0665V12.4497H2.08447V22.0665H3.08447ZM3.08447 12.4497C3.08447 12.3318 3.13412 12.2264 3.21507 12.1518L2.53738 11.4165C2.25954 11.6725 2.08447 12.041 2.08447 12.4497H3.08447ZM3.33075 11.9925L6.62022 4.81583L5.71116 4.39916L2.4217 11.5758L3.33075 11.9925ZM6.61769 4.82127C7.64802 2.64285 9.84201 1.25369 12.2515 1.25369V0.253693C9.45537 0.253693 6.90936 1.86574 5.7137 4.39371L6.61769 4.82127ZM12.2515 1.25369H20.8471V0.253693H12.2515V1.25369ZM20.8471 1.25369C23.2072 1.25369 25.3645 2.5862 26.4203 4.69679L27.3147 4.24939C26.0893 1.79999 23.5858 0.253693 20.8471 0.253693V1.25369ZM26.4194 4.69493L30.1081 12.146L31.0043 11.7023L27.3156 4.25126L26.4194 4.69493Z",
    fill: "#004733"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03641 11.8633C5.75915 11.8633 5.57162 11.6281 5.67646 11.4141L8.28148 6.09696C9.16999 4.52466 11.0616 2.86328 13.1397 2.86328H20.0002C22.0356 2.86328 23.8953 4.4844 24.806 6.0074L27.6142 11.4073C27.7261 11.6226 27.5375 11.8633 27.2575 11.8633H6.03641Z",
    fill: "#EDEDED",
    stroke: "#004733"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3736 20.1552H14.3108C13.8578 20.1552 13.4888 19.7874 13.4888 19.3332V18.888C13.4888 18.4338 13.8578 18.066 14.3108 18.066H19.3736C19.8278 18.066 20.1956 18.4338 20.1956 18.888V19.3332C20.1956 19.7874 19.8278 20.1552 19.3736 20.1552Z",
    fill: "#004733"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6916 15.5697L24.9298 17.6991C24.5356 17.9883 23.9656 17.9241 23.6554 17.5551L23.1448 16.9455C22.6768 16.3869 23.1016 15.5697 23.8588 15.5697H27.6916Z",
    stroke: "#004733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61719 15.5697L8.37899 17.6991C8.77379 17.9883 9.34379 17.9241 9.65339 17.5551L10.1646 16.9455C10.6326 16.3869 10.2078 15.5697 9.45059 15.5697H5.61719Z",
    stroke: "#004733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9114 15.5697H6.05176",
    stroke: "#004733",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.4626d8ba.svg";
export { ForwardRef as ReactComponent };